<template>
    <div class="content">
        <div class="content-wrap">
            <div class="top">
                <mq-layout mq="mobile">
                    <MobileMenubar></MobileMenubar>
                </mq-layout>
                <mq-layout mq="laptop+">
                    <LaptopMenubar></LaptopMenubar>
                </mq-layout>
            </div>

            <div class="container-login">
                <div class="main-text" align="center">
                    <p class="big-text" align="center">{{l10.All_Parents_SignupAgreement_Title1}}</p>
                    <p class="sub-text" align="center">{{l10.All_Parents_SignupAgreement_Title1_Description1}}</p>
                </div>
                
                <div class="label-box">
                    <ul>
                    <li>
                    <label class="checkbox-label" align="left">{{l10.All_Parents_SignupAgreement_Title1_Description2}}
                        <input type="checkbox" v-model="adultAgreement">
                        <span class="checkbox-custom"></span>
                    </label>
                    </li>
                    <li>
                    <label class="checkbox-label">{{l10.All_Parents_SignupAgreement_Title1_Description3}}
                        <input type="checkbox" v-model="marketingAgreement">
                        <span class="checkbox-custom"></span>
                    </label>
                    </li>
                    </ul>
                </div>

                <div v-if="msg" class="wrong-text">{{msg}}</div>
                
                <div class="info-text" align="center">{{tosAndPi[0]}}
                    <a href="https://enuma.com/tos" target="_blank" rel="noopener noreferrer">{{tosAndPi[1]}}</a>{{tosAndPi[2]}}
                    <a href="https://enuma.com/policy" target="_blank" rel="noopener noreferrer">{{tosAndPi[3]}}</a>{{tosAndPi[4]}}
                </div>

                <div class="check-button" align="center">
                    <input class="subm" @click="ok" type="button" align="center" :disabled="!adultAgreement"
                        :value="[[ l10.All_Parents_SignupAgreement_Title1_Button1 ]]"
                    />
                </div> 
            </div>

        </div>

        <div class="container">
            <mq-layout mq="mobile">
                <MobileFooter></MobileFooter>
            </mq-layout>
            <mq-layout mq="laptop+">
                <LaptopFooter></LaptopFooter>
            </mq-layout>
        </div>

        <modal name="msgPopup"
            :classes="'msgPopup'"
            :clickToClose="false"
            :width="500"
            :height="'auto'">
            <div class="popup" align="center">
                <div class="content"><pre>{{msg}}</pre></div>
                <button @click="goSignin" class="okbutton" align="center">{{ l10.All_Parents_FindPassword_Title1_Button2 }}</button>
            </div>
        </modal>

    </div>
</template>
<script>
import LaptopMenubar from '@/components/menubar/LaptopLayout.vue'
import MobileMenubar from '@/components/menubar/MobileLayout.vue'
import LaptopFooter from "@/components/footer/FooterLaptop.vue";
import MobileFooter from "@/components/footer/FooterMobile.vue";

import axios from 'axios'

export default {
    name: "SignupAgreement",
    components: { LaptopMenubar, MobileMenubar, LaptopFooter, MobileFooter },

    created() {
        console.log(this.tosAndPi);
        // if (this.googleToken) {
        //     return;
        // } else if (this.email && this.password) {
        //     return;
        // } else {
        //     this.$router.push("/notFound");
        //     return;
        // }
    },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        return {
            env: this.$store.state.env,
            l10: l10n,
            googleToken: this.$store.state.googleToken,
            email: this.$store.state.email,
            password: this.$store.state.password,
            adultAgreement: true,
            marketingAgreement: true,
            msg: "",
            tosAndPi: l10n.All_Parents_SignupAgreement_Title1_Description4.split(/{|}/),
        };
    },
    methods: {
        redirect() {
            this.$store.dispatch("redirect");
        },
        async ok() {
            if (this.googleToken) {
                const token = this.googleToken;
                const marketingAgreement = this.marketingAgreement;
                this.$store
                    .dispatch("signinGoogle", { token, marketingAgreement })
                    .then(() => {
                        this.redirect();
                    })
                    .catch(({ message }) => {
                        this.setErrorMsg(this.$store.state.errCode);
                        this.$modal.show('msgPopup');
                    });
            } else if (this.email && this.password) {
                const email = this.email;
                const password = this.password;
                const marketingAgreement = this.marketingAgreement;
                const signup = await axios.post(
                    this.env.protocol + this.env.urlAPI + "/account/signup", {
                        accountType: 'personal',
                        email: email,
                        password: password,
                        marketingAgreement: marketingAgreement,
                        installId: 'internal',
                        product: 'todomath',
                        fromWeb: true
                    },
                    {
                        headers: {
                            "content-type": "application/json; charset=UTF-8"
                        }
                    }
                );
                if (!signup.data.result) {
                    this.setErrorMsg(checkRes.data.errorCode);
                    this.$modal.show('msgPopup');
                    return;
                }

                this.$store
                    .dispatch("signin", { email, password })
                    .then((data) => {
                        this.redirect();
                    })
                    .catch(({ message }) => {
                        this.setErrorMsg(this.$store.state.errCode);
                        this.$modal.show('msgPopup');
                    });
            }
        },
        goSignin() {
            const { search } = window.location;
            this.$router.push("/signin" + search)
        },
        setErrorMsg(errCode) {
            if ( "All_Parents_Error_" + errCode in this.l10) {
                this.msg = this.l10["All_Parents_Error_" + errCode];
            } else {
                this.msg = "Unknown error occurred.";
            }
        },
        
    }
};


</script>

<style src="@/assets/account/main.css"></style>
<style scoped>
.top {
    height: 100px;
    background-color: #42c0ff;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    max-width: 1024px;
    background-color: #ffffff;
}
.content-wrap {
    background-color: #fffcf7;
    padding-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/account/SignupAgreement.vue